import {
    temAcesso
} from '@/shared/auth/temAcesso'

const Pagamentos = () => import('./Pagamentos.vue')

export default {
    path: 'pagamentos',
    name: 'FornecedorPagamentos',
    component: Pagamentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('FORN-PAG-00')) {
            next()
        }
    },
    children: [
        // {
        // path: 'atualizar',
        // name: 'FornecedorDadosCadastrais_Atualizar',
        // component: DadosCadastraisForm,
        // beforeEnter: (to, from, next) => {
        //     if (temAcesso('FORN-DADOS-01')) {
        //         next()
        //     }
        // }
        // }
    ]
}
